import script from "./LaputaHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaHeader.vue?vue&type=script&setup=true&lang=js"

import "./LaputaHeader.vue?vue&type=style&index=0&id=23142136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23142136"]])

export default __exports__